import React from 'react';
import Paper from '@material-ui/core/Paper';
import { Helmet } from 'react-helmet';

import Form from '../childrens/form/.mixins';

class Temas extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Temas`}</title>
                </Helmet>
                <Paper elevation={2} style={{padding:'20px'}}>
                    <Form/>
                </Paper>
            </>
        );
    }

};

export default Temas;